<template>
    <v-main>
        <div>
            <v-card flat class="ma-2">
                <div v-if="params[0] != 'huis'">
                    <v-row cols="12" no-gutters class="mb-2">
                        <h2>{{this.title}}</h2>
                    </v-row>
                </div>
                <div v-else>
                    <v-row cols="12" no-gutters class="mb-2">
                        <v-col cols="4">
                            <h2>{{this.title}}</h2>
                            <h5 class="subtitle-weight mt-2">(Nr. of reviews in selection: <b>{{ this.filteredReviews.length }}</b>, {{this.resetdate}})</h5>
                        </v-col>
                        <v-col cols="3">                        
                            <v-text-field class="pl-1 pt-2" dense v-model="revw_key" clearable prepend-icon="mdi-filter-outline"
                            label="Filter on review key" single-line hide-detail />                        
                        </v-col>                            
                    </v-row>
                </div>
                <v-row cols="12" no-gutter dense>
                    <v-col cols="12">
                        <div v-if="params[0] != 'huis'">
                            <h5 class="subtitle-weight">(Nr. of reviews in selection: <b>{{ this.filteredReviews.length }}</b>)</h5>
                        </div>
                    </v-col>
                </v-row>
                <v-row cols="12" no-gutter dense>
                    <v-col cols="2">
                        <v-text-field class="pt-1" dense v-model="search" clearable prepend-icon="mdi-magnify"
                            label="Search through all fields" single-line hide-detail />
                    </v-col>
                    <v-col cols="2" v-if="params[0] != 'user'">
                        <v-select v-model="selected_gebr" @change="toggle0" v-bind:items="gebr"
                            prepend-icon="mdi-filter-outline" item-value="code" item-text="name" label="Assigned to"
                            dense class="pl-3 pt-1" clearable></v-select>
                    </v-col>

                    <v-col cols="3">
                        <v-select v-model.lazy="selected_revwstats" v-bind:items="revwstats" @change="toggle0"
                            multiple prepend-icon="mdi-filter-outline" item-value="code" item-text="description"
                            label="Status" dense class="pl-1 pt-1" clearable>
                            <template v-slot:prepend-item>
                                <!-- select all + deselect all -->
                                <v-list-item ripple @mousedown.prevent @click="toggle">
                                    <v-list-item-action>
                                        <v-icon :color="selected_revwstats.length > 0 ? 'indigo darken-4' : ''">{{
                                        icon }}</v-icon>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-title>Select All</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-divider class="mt-2"></v-divider>
                            </template>
                            <template v-slot:selection="{ item, index }">
                                <!-- so the select element will remain single-line and not push the overview down forcing ugly sidebars to show -->
                                <span>
                                    <span v-if="index <=1"><span v-if="index === 1">,&nbsp;</span>{{
                                    item.description }}</span>
                                    <span v-if="index === 2" class="grey--text">&nbsp;...(+{{
                                    selected_revwstats.length - 2 }} others)</span>
                                </span>
                            </template>
                        </v-select>
                    </v-col>

                    <v-col cols="2">
                        <v-select v-model.lazy="selected_revwpartners" v-bind:items="revwpartners" @change="toggle0"
                            multiple prepend-icon="mdi-filter-outline" item-value="code" item-text="description"
                            label="Partner" dense class="pt-1 pr-2 pl-1" clearable>
                            <template v-slot:prepend-item>
                                <!-- select all + deselect all -->
                                <v-list-item ripple @mousedown.prevent @click="toggle2">
                                    <v-list-item-action>
                                        <v-icon :color="selected_revwpartners.length > 0 ? 'indigo darken-4' : ''">
                                            {{ icon2 }}</v-icon>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-title>Select All</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-divider class="mt-2"></v-divider>
                            </template>
                            <template v-slot:selection="{ item, index }">
                                <!-- so the select element will remain single-line and not push the overview down forcing ugly sidebars to show -->
                                <span>
                                    <span v-if="index <=1"><span v-if="index === 1">,&nbsp;</span>{{
                                    item.description }}</span>
                                    <span v-if="index === 2" class="grey--text">&nbsp;...(+{{
                                    selected_revwpartners.length - 2 }} others)</span>
                                </span>
                            </template>
                        </v-select>
                    </v-col>
                    <v-col cols="2">
                        <v-select v-model.lazy="selected_scores" v-bind:items="scores" @change="toggle0" multiple
                            prepend-icon="mdi-filter-outline" item-value="code" item-text="description"
                            label="Score" dense class="pt-1 pr-16 pl-1" clearable>
                            <template v-slot:prepend-item>
                                <!-- select all + deselect all -->
                                <v-list-item ripple @mousedown.prevent @click="toggle3">
                                    <v-list-item-action>
                                        <v-icon :color="selected_scores.length > 0 ? 'indigo darken-4' : ''">{{
                                        icon3 }}</v-icon>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-title>Select All</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-divider class="mt-2"></v-divider>
                            </template>
                            <template v-slot:selection="{ item, index }">
                                <!-- so the select element will remain single-line and not push the overview down forcing ugly sidebars to show -->
                                <span>
                                    <span v-if="index <=1"><span v-if="index === 1">,&nbsp;</span>{{
                                    item.description }}</span>
                                    <span v-if="index === 2" class="grey--text">&nbsp;...(+{{ selected_scores.length
                                    - 2 }} others)</span>
                                </span>
                            </template>
                        </v-select>
                    </v-col>
                    <v-col cols="1">
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on" medium color="green"
                                    v-on:click="exportDataToExcel()" class="mt-2">mdi-microsoft-excel</v-icon>
                            </template>
                            <span>Export data to Excel</span>
                        </v-tooltip>
                        <span v-if="this.selected_selected.length > 0">
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon v-bind="attrs" v-on="on" medium v-on:click="fPubl()" class="mt-2 ml-4">
                                        mdi-fast-forward-outline</v-icon>
                                </template>
                                <span>Publish selection</span>
                            </v-tooltip>
                        </span>
                    </v-col>
                </v-row>
            </v-card>

            <v-card flat>
                <v-row>
                    <v-col></v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="12" class="px-2">
                        <v-data-table :headers="getHeaders(this.params[0])" :must-sort=true :items="filteredReviews"
                            :search="search" :disable-pagination=true :loading="loading" :height="wInnerHeight" flat
                            dense fixed-header loading-text="Loading data...please wait"
                            no-data-text="No reviews to display" hide-default-footer>
                            <!--
                            <template v-slot:header.upd>
                                <v-icon small>mdi-file-document-edit-outline</v-icon>
                            </template>     
                            -->
                            <template v-slot:header.selected>
                                <v-icon medium ripple @mousedown.prevent @click="toggle4">{{icon4}}</v-icon>
                            </template>
                            <!-- alpha-e-circle -->

                            <template v-slot:item="review">
                                <tr>
                                    <td class="checkbox_markup">
                                        <v-simple-checkbox small v-model="review.item.selected"
                                            v-on:click="updateSelectedSelected(review.item)"></v-simple-checkbox>
                                    </td>
                                    <td class="td_markup">{{review.item.revw_source}}</td>
                                    <td class="td_markup">{{review.item.ABB_Account}}</td>
                                    <td class="td_markup">
                                        <!-- <v-layout> -->
                                            <div style="display: flex; flex-direction: row;">
                                                <div v-if="review.item.cttp_nr==='5'"><v-icon color="error">mdi-alpha-e-circle</v-icon></div>
                                                <div v-if="review.item.revw_language_code !== review.item.use_language_code" ><v-icon color="success">mdi-alpha-t-circle</v-icon></div>                                        
                                                <div v-if="review.item.revw_language_code === review.item.use_language_code" ><v-icon color="transparent">mdi-alpha-t-circle</v-icon></div>                                        
                                                <div v-if="review.item.revw_language_code !== review.item.use_language_code&&review.item.cttp_nr!=='5'" ><v-icon color="transparent">mdi-alpha-t-circle</v-icon></div>                                        
                                            </div>    
                                        <!-- </v-layout> -->
                                    </td>
                                    <!-- <td class="td_markup" v-if="review.item.cttp_nr==='5'"><v-icon color="error">mdi-alpha-e-circle</v-icon></td>
                                    <td class="td_markup" v-else><v-icon color="transparent">mdi-alpha-e-circle</v-icon></td> -->
                                    <!--
                                    <td class="td_markup"
                                        @click="$router.open('/huis/onHuis/' + review.item.huis_encrid)"><a>
                                            {{review.item.huis_code}} </a></td>
                                    -->    
                                    
                                    <td class="td_markup" v-if="params[0]!=='huis'">
                                        <v-layout justify-start>
                                        
                                        <span @click="$router.open('/huis/onHuis/' + review.item.huis_encrid)"><a>{{review.item.huis_code}}</a></span> 
                                            <v-spacer></v-spacer>
                                            <span v-if="review.item.avgReviewScoreRnd===1">
                                                <v-avatar size="30" class="ml-3 logo_row_2 acco_score1" @click="openAccoPage(review.item.huis_encrid)">{{review.item.avgReviewScore}}</v-avatar>
                                            </span>
                                            <span v-else-if="review.item.avgReviewScoreRnd===2">
                                                <v-avatar size="30" class="ml-3 logo_row_2 acco_score2" @click="openAccoPage(review.item.huis_encrid)">{{review.item.avgReviewScore}}</v-avatar>
                                            </span>
                                            <span v-else-if="review.item.avgReviewScoreRnd===3">
                                                <v-avatar size="30" class="ml-3 logo_row_2 acco_score3" @click="openAccoPage(review.item.huis_encrid)">{{review.item.avgReviewScore}}</v-avatar>
                                            </span>
                                            <span v-else-if="review.item.avgReviewScoreRnd===4">
                                                <v-avatar size="30" class="ml-3 logo_row_2 acco_score4" @click="openAccoPage(review.item.huis_encrid)">{{review.item.avgReviewScore}}</v-avatar>
                                            </span>
                                            <span v-else-if="review.item.avgReviewScoreRnd===5">
                                                <v-avatar size="30" class="ml-3 logo_row_2 acco_score5" @click="openAccoPage(review.item.huis_encrid)">{{review.item.avgReviewScore}}</v-avatar>
                                            </span>
                                        </v-layout>
                                    </td>

                                    <td class="td_markup">
                                        <div>
                                            <div style="display: flex; flex-direction: row; column-gap: 5px;">
                                                <div>C</div>
                                                <div>
                                                    {{getDateFormat(review.item.revw_date_created)}}
                                                </div>
                                            </div>
                                            <div style="display: flex; flex-direction: row; column-gap: 5px;">
                                                <div>A</div>
                                                <div>
                                                    {{getDateFormat(review.item.dateInAres)}}
                                                </div>
                                            </div>
                                            <div style="display: flex; flex-direction: row; column-gap: 5px;" :class="{'go': review.item.dateForReactionColor===0, 'nogo': review.item.dateForReactionColor===1}">
                                                <div>R</div>
                                                <div>
                                                    {{getDateFormat(review.item.dateForReaction)}}
                                                </div>
                                            </div>    
                                        </div>     
                                    </td>
                                    <td class="td_markup" :class="{'wrn': review.item.table==='revw'&&review.item.klnt_encrid!==''}">
                                        <div v-if="review.item.klnt_encrid!==''">
                                            <span
                                                @click="$router.open('/klnt/onKlnt/' + review.item.klnt_encrid)"><a>
                                                    {{review.item.revw_customerfirstname}} {{review.item.revw_customername}} </a></span>
                                        </div>
                                        <div v-else>
                                            <span>{{review.item.revw_customerfirstname}}</span>
                                        </div>
                                    </td>
                                    <td class="td_markup" :class="{'wrn': review.item.table==='revw'&&review.item.klnt_encrid!==''}">
                                        <div v-if="review.item.huov_encrid!==''">
                                            <span
                                                @click="$router.open('/huov/onHuov/' + review.item.huov_encrid)"><a>
                                                    {{review.item.booking}} </a></span>
                                        </div>
                                        <div v-else>
                                            <span>{{review.item.booking}}</span>
                                        </div>
                                    </td>
                                    <td class="td_markup">{{review.item.assigned_display_name}}</td>
                                    <td class="td_markup score">
                                        <v-layout justify-center>
                                            <v-avatar size="30" :color="review.item.revw_score_color">
                                                <b>{{review.item.revw_score}}</b>
                                            </v-avatar>
                                        </v-layout>
                                    </td>
                                    <td class="td_markup">
                                        <v-layout justify-center>{{review.item.revw_language_code}}</v-layout>
                                    </td>
                                    <td class="td_markup">
                                        <v-layout justify-start>{{review.item.revw_text}}
                                            <v-spacer></v-spacer>
                                            <span v-if="review.item.revw_text!=''">
                                                <v-avatar
                                                    v-on:click="showReaction(review.item.table, review.item.encrid, 'Review', 'GuestBook')"
                                                    size="30" color="white" class="ml-3 logo_row_2">
                                                    <v-icon>mdi-dots-horizontal</v-icon>
                                                </v-avatar>
                                            </span>
                                        </v-layout>
                                    </td>
                                    <td class="td_markup">{{review.item.status}}</td>
                                    <td class="td_markup">
                                        <v-layout justify-center>
                                            <span v-if="review.item.revw_reaction_host">
                                                <v-tooltip top :max-width="400" offset-y>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-avatar
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            v-on:click="showReaction(review.item.table, review.item.encrid, 'Reaction Host', 'ReactionHost')"
                                                            size="30" color="white" class="logo_row_2">
                                                            <v-icon color="pink">mdi-check-bold</v-icon>
                                                        </v-avatar>
                                                    </template>
                                                    <span>{{ review.item.revw_reactionhost_text }}</span>
                                                </v-tooltip>
                                            </span>
                                            <span v-else>
                                                <v-avatar size="30" color="transparant" class="logo_row_2">
                                                </v-avatar>
                                            </span>
                                        </v-layout>
                                    </td>
                                    <td class="td_markup">
                                        <v-layout justify-center>
                                            <span v-if="review.item.revw_reaction">
                                                <v-tooltip top :max-width="400" offset-y>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-avatar
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            v-on:click="showReaction(review.item.table, review.item.encrid, 'Reaction VFY', 'ReactionVFY')"
                                                            size="30" color="white" class="logo_row_2">
                                                            <v-icon color="success">mdi-check-bold</v-icon>
                                                        </v-avatar>
                                                    </template>
                                                    <span>{{ review.item.revw_reactionvfy_text }}</span>
                                                </v-tooltip>
                                            </span>
                                            <span v-else>
                                                <v-avatar size="30" color="transparant" class="logo_row_2">
                                                </v-avatar>
                                            </span>
                                        </v-layout>
                                    </td>
                                    <td class="td_markup">
                                        <v-layout justify-center>
                                            <span v-if="review.item.revw_tiphost">
                                                <v-tooltip top :max-width="400" offset-y>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-avatar
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            v-on:click="showReaction(review.item.table, review.item.encrid, 'Tips for Host', 'TipsForHost')"
                                                            size="30"
                                                            color="white">
                                                            <v-icon color="blue">mdi-check-bold</v-icon>
                                                        </v-avatar>
                                                    </template>
                                                    <span>{{ review.item.revw_tipsforhost_text }}</span>
                                                </v-tooltip>
                                            </span>
                                            <span v-else>
                                                <v-avatar size="30" color="transparant">
                                                </v-avatar>
                                            </span>
                                        </v-layout>
                                    </td>
                                    <td class="td_markup">
                                        <v-layout justify-center>
                                            <span v-if="review.item.revw_tipvfy">
                                                <v-tooltip top :max-width="400" offset-y>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-avatar
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            v-on:click="showReaction(review.item.table, review.item.encrid, 'Tips for Villa for You', 'TipsForVFY')"
                                                            size="30" color="white">
                                                            <v-icon color="orange">mdi-check-bold</v-icon>
                                                        </v-avatar>
                                                    </template>
                                                    <span>{{ review.item.revw_tipsforvfy_text }}</span>
                                                </v-tooltip>
                                            </span>
                                            <span v-else>
                                                <v-avatar size="30" color="transparant">
                                                </v-avatar>
                                            </span>
                                        </v-layout>
                                    </td>                                                                                
                                    <td class="td_markup">
                                        <div v-if="!review.item.isLoading">
                                            <v-avatar v-if="!getAuth()" v-on:click="showReview(review)"
                                                size="30" color="white" class="ml-3 logo_row_2">
                                                <v-icon medium>mdi-playlist-edit</v-icon>
                                            </v-avatar>
                                            <v-avatar v-else v-on:click="$router.open(`/task/customer_success/revw/onReview2/${review.item.table}:${review.item.encrid}`)"
                                                size="30" color="orange" class="ml-3 logo_row_2">
                                                <v-icon medium>mdi-playlist-edit</v-icon>
                                            </v-avatar>                        
                                        </div>     
                                        <div v-else class="ml-3 logo_row_2">
                                            <v-progress-circular :width="3" :size="20" color="green" indeterminate></v-progress-circular>
                                        </div>               
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
                <show_text ref="showtext" />
                <showReview ref="showreview" @review-loaded="stopSpinner" />
            </v-card>
        </div>
        <fPubl ref="fPubl" />
        <navBar title="Ares - Customer Success" :home="true" type="customersuccess" goto="/task/customer_success/mnCustomerSuccess" v-if="this.params[0] == 'all'"/>
        <navBar title="Ares - Overview" :home="true" goto="/task/customer_success/mnCustomerSuccess" v-else/>
    </v-main>
</template>
  
<script>

import { bus } from "../../../../main";

import show_text from "@/components/show_text_lng.vue";
import showReview from "@/views/task/customer_success/revw/onReview";
import mxgetuser from '@/mixins/getuser';
import mxgetrevwstats from '@/mixins/revw/getrevwstats';
import mxfindwithattribute from '@/mixins/findwithattribute';
import navBar from "@/components/ui/navbars/navbar.vue";
import fPubl from "@/views/task/customer_success/revw/fastPublication.vue";

export default {
    components: { 
        show_text, 
        showReview, 
        navBar, 
        fPubl,
    },
    props: ['param'],
    data() {
        return {
            reviews: [],
            loading: false,
            params: [],
            search: '',
            revw_key: '',
            selected_gebr: '',
            user: '',
            title: '',
            resetdate: '',
            revwstats: [],
            revwpartners: [],
            selected_revwpartners: [],
            selected_revwstats: [],
            scores: [],
            selected_scores: [],
            selected_scores2: [],
            selected_selected: [],
            wInnerHeight: window.innerHeight - 230, // deduct estimated height for toolbar, searchfield and headers
        }
    },
    computed: {
        filteredReviews: function () {
            return this.reviews.filter((review) => {
                var matches_user;
                if (this.selected_gebr === null || this.selected_gebr === '') {
                    matches_user = true;
                } else {
                    matches_user = review.assigned.match(this.selected_gebr)
                }
                var matches_state;
                //console.log(this.selected_revwstats.length, this.selected_revwstats.length === this.revwstats.length);
                if (this.selected_revwstats.length === 0 || this.selected_revwstats.length === this.revwstats.length) {
                    // console.log(this.selected_revwstats);
                    // console.log("beschikbare statussen", JSON.stringify(this.revwstats), review.status.trim());
                    var idx = this.findWithAttr(this.revwstats, "code", review.status.trim());  // here we can use the complete list (nonthing selected, all selected is the same)
                    if(idx !== -1){
                        matches_state = true;
                    } else {
                        matches_state = false;
                    }
                    // console.log(matches_state);
                } else {
                    if (review.status.trim() === '') {
                        matches_state = true;
                    } else {
                        const foundstat = this.selected_revwstats.find(element => element === review.status);
                        if (typeof foundstat !== 'undefined') {
                            matches_state = true;
                        }
                    }
                }
                var matches_partner;
                if (this.selected_revwpartners.length === 0 || this.selected_revwpartners.length === this.revwpartners.length) {
                    matches_partner = true;
                } else {
                    const foundpartner = this.selected_revwpartners.find(element => element === review.revw_source.toLowerCase());
                    if (typeof foundpartner !== 'undefined') {
                        matches_partner = true;
                    }
                }
                var matches_score;
                if (this.selected_scores.length === 0 || this.selected_scores.length === this.scores.length) {
                    matches_score = true;
                } else {
                    const foundscore = this.selected_scores.find(element => element == review.revw_score); // == somewhat the same, do conversion if needed, === is exact match including datatype
                    if (typeof foundscore !== 'undefined') {
                        matches_score = true;
                    }
                }
                if(this.params[0] === 'huis'){
                    var matches_key;
                    if(this.revw_key === '' || this.revw_key === null){
                        matches_key = true;
                    } else {
                        matches_key = review.key.match(this.revw_key);
                    }
                    return matches_user && matches_state && matches_partner && matches_score && matches_key;
                }else {
                    return matches_user && matches_state && matches_partner && matches_score;
                }
            });
        },
        icon: function () {
            if (this.selectAll) return 'mdi-close-box'
            if (this.selectSome) return 'mdi-minus-box'
            return 'mdi-checkbox-blank-outline'
        },
        selectAll: function () {
            return this.selected_revwstats.length === this.revwstats.length; // stats declared in mixin
        },
        selectSome: function () {
            return this.selected_revwstats.length > 0 && !this.selectAll;
        },
        icon2: function () {
            if (this.selectAll2) return 'mdi-close-box'
            if (this.selectSome2) return 'mdi-minus-box'
            return 'mdi-checkbox-blank-outline'
        },
        selectAll2: function () {
            return this.selected_revwpartners.length === this.revwpartners.length; // stats declared in mixin
        },
        selectSome2: function () {
            return this.selected_revwpartners.length > 0 && !this.selectAll2;
        },
        icon3: function () {
            if (this.selectAll3) return 'mdi-close-box'
            if (this.selectSome3) return 'mdi-minus-box'
            return 'mdi-checkbox-blank-outline'
        },
        selectAll3: function () {
            return this.selected_scores.length === this.scores.length; // stats declared in mixin
        },
        selectSome3: function () {
            return this.selected_scores.length > 0 && !this.selectAll3;
        },
        icon4: function () {
            if (this.selectAll4) return 'mdi-close-box'
            if (this.selectSome4) return 'mdi-minus-box'
            return 'mdi-checkbox-blank-outline'
        },
        selectAll4: function () {
            //console.log('selectall4', this.selected_selected.length === this.filteredReviews.length, this.selected_selected.length, this.filteredReviews.length);
            return this.selected_selected.length === this.filteredReviews.length && this.selected_selected.length !== 0 && this.filteredReviews.length !== 0;
            //var t = this.filteredReviews.filter(review => review.selected).length;
            //return t === this.filteredReviews.length && t !== 0 && this.filteredReviews.length !== 0; // stats declared in mixin
        },
        selectSome4: function () {
            return this.selected_selected.length > 0 && this.selected_selected.length !== this.filteredReviews.length;
            //var t = this.filteredReviews.filter(review => review.selected).length;
            //return t > 0 && t !== this.filteredReviews.length;
        },

    },
    destroyed() {
        window.removeEventListener("resize", this.resizeEventHandler);
        window.removeEventListener('storage', this.storageEventHandler);
    },
    created() {

        bus.$on("updateReviewList", (data) => {
            if (data != null) {
                var idx = this.findWithAttr(this.reviews, "encrid", data.encrid);
                //console.log("found element ", idx);
                if (idx !== -1) {
                    if(data.status!==this.reviews[idx].status){
                        this.reviews[idx].selected = false; // if this record falls out of scope due a status change this should be unselected to avoid non visible selected records
                    }
                    this.reviews[idx].status = data.status;
                    this.reviews[idx].assigned = data.gebr_code;
                    this.reviews[idx].assigned_display_name = data.display_name;
                    this.reviews[idx].revw_score = data.score;
                    this.reviews[idx].revw_score_color = data.color_code;
                    this.reviews[idx].revw_text = data.gastenboek;
                    this.reviews[idx].revw_reaction = (data.reaction_vfy.trim() !== '');                    
                }
            }
        });

        bus.$on("updateReviewListFastPublication", (data, user) => {
            // console.log(user, data != null);
            if (data.length != 0) {
                //console.log('reviews', data.length);
                data.forEach((element) => {
                    var idx = this.findWithAttr(this.reviews, "encrid", element.encrid);
                    //console.log("found element ", idx);
                    if (idx !== -1) {
                        this.reviews[idx].status = "Published";
                        this.reviews[idx].assigned = user;
                    }

                });
            }
            this.toggle0(); // reset selection to unselected
        });


        // console.log('created');
        this.loading = true;

        // console.log('param', this.param);
        if (this.param !== null) {
            this.params = this.param.split(":");
        }

        window.addEventListener("resize", this.resizeEventHandler);
        window.addEventListener('storage', this.storageEventHandler)
        this.loadData();


    },
    mixins: [mxgetuser, mxgetrevwstats, mxfindwithattribute],
    methods: {
        updateSelectedSelected(param) {
            //console.log(param);
            if (param.selected) {
                // console.log('add');
                this.selected_selected.push(param);
            } else {
                // console.log('remove');
                var idx = this.findWithAttr(this.selected_selected, "key", param.key);
                this.selected_selected.splice(idx, 1);
            }
            //console.log('selected', JSON.stringify(this.selected_selected));
        },
        openAccoPage(encrid) {
            let route = this.$router.resolve({ path: `/task/customer_success/revw/revw_overview3/huis:${encrid}` }); 
            window.open(route.href, '_blank');
        },
        fPubl() {
            this.$refs.fPubl.open(this.selected_selected, this.user);
        },
        storageEventHandler(e) {
            if(e.key==='reload_reviews'){
                this.loadData();  
            }
        },
        resizeEventHandler() {
            this.wInnerHeight = window.innerHeight - 230; // deduct estimated height for toolbar, searchfield and headers
        },
        getHeaders(v) {
            if(v==='huis'){
                return [
                    { text: "", value: "selected", sortable: false, width: "1%" },
                    { text: "Source", value: "revw_source", width: "3%" },
                    { text: "A", value: "ABB_Account", width: "3%" },
                    { text: "", value: "ABB_Accountfull", width: "0%", class: "d-none" }, // Hidden for search
                    { text: "Ctr", value: "cttp_nr", width: "4%", align: "start", sortable: true },
                    { text: "Created", value: "revw_date_created", align: "start", width: "5%" },
                    { text: "Guest", value: "revw_customername", align: "start", width: "4%" },
                    { text: "Booking", value: "booking", align: "start", width: "4%" },
                    { text: "Assigned", value: "assigned", align: "start", width: "4%" },
                    { text: "", value: "revw_score", sortable: true, align: "center", width: "1%" },
                    { text: "Lng", value: "revw_language_code", sortable: false, align: "center", width: "1%" },
                    { text: "Review", value: "revw_text", sortable: false, align: "start", width: "20%" },
                    { text: "Status", value: "status", sortable: true, align: "start", width: "4%" },
                    { text: "RH", value: "revw_reaction_host", sortable: false, align: "center", width: "1%" },
                    { text: "RVfY", value: "revw_reaction", sortable: false, align: "center", width: "1%" },
                    { text: "TH", value: "revw_reaction", sortable: false, align: "center", width: "1%" },
                    { text: "TVfY", value: "revw_reaction", sortable: false, align: "center", width: "1%" },
                    { text: "", value: "upd", sortable: false, align: "center", width: "1%" }
                ];
            } else {
                return [
                    { text: "", value: "selected", sortable: false, width: "1%" },
                    { text: "Source", value: "revw_source", width: "3%" },
                    { text: "A", value: "ABB_Account", width: "3%" },
                    { text: "", value: "ABB_Accountfull", width: "0%", class: "d-none" }, // Hidden for search
                    { text: "Ctr", value: "cttp_nr", width: "4%", align: "start", sortable: true},
                    { text: "Acco", value: "huis_code", width: "3%" },
                    { text: "Created", value: "revw_date_created", align: "start", width: "5%" },
                    { text: "Guest", value: "revw_customername", align: "start", width: "4%" },
                    { text: "Booking", value: "booking", align: "start", width: "4%" },
                    { text: "Assigned", value: "assigned", align: "start", width: "4%" },
                    { text: "", value: "revw_score", sortable: true, align: "center", width: "1%" },
                    { text: "Lng", value: "revw_language_code", sortable: false, align: "center", width: "1%" },
                    { text: "Review", value: "revw_text", sortable: false, align: "start", width: "20%" },
                    { text: "Status", value: "status", sortable: true, align: "start", width: "4%" },
                    { text: "RH", value: "revw_reaction_host", sortable: false, align: "center", width: "1%" },
                    { text: "RVfY", value: "revw_reaction", sortable: false, align: "center", width: "1%" },
                    { text: "TH", value: "revw_reaction", sortable: false, align: "center", width: "1%" },
                    { text: "TVfY", value: "revw_reaction", sortable: false, align: "center", width: "1%" },
                    { text: "", value: "upd", sortable: false, align: "center", width: "1%" }
                ];
            }
        },
        exportDataToExcel() {
            // console.log('export to excel')

            var e_reviews = [];

            for (let t = 0; t < this.filteredReviews.length; t++) {

                var el = new Object();

                el["Source"] = this.filteredReviews[t].revw_source;
                el["Accommodation"] = this.filteredReviews[t].huis_code;
                if(this.params[0] !== 'huis'){
                    el["Acco. avg."] = this.filteredReviews[t].avgReviewScore;
                }                
                el["Created"] = new Date(this.filteredReviews[t].revw_date_created)
                el["Customer"] = this.filteredReviews[t].revw_customername;
                el["Booking"] = this.filteredReviews[t].booking;
                el["Assigned"] = this.filteredReviews[t].assigned;
                el["Assigned full name"] = this.filteredReviews[t].assigned_display_name;
                el["Score"] = this.filteredReviews[t].revw_score;
                el["Language"] = this.filteredReviews[t].revw_language_code;
                el["Review"] = this.filteredReviews[t].revw_text;
                el["Status"] = this.filteredReviews[t].status;
                el["Reaction VFY"] = this.filteredReviews[t].revw_recation;
                el["Table"] = this.filteredReviews[t].table;
                el["Key"] = this.filteredReviews[t].key;
                e_reviews.push(el);

            }

            var XLSX = require("xlsx");
            var ws = XLSX.utils.json_to_sheet(e_reviews);
            var wb = XLSX.utils.book_new();

            // totals
            var cell = "A" + (e_reviews.length + 3); // 1 = empty line, 1 = columnheaders, 1 is actual line we need to be (=3)
            // the prepended + sign makes sure that Excel understands it's a number. Passing it this way enables you to calculate with the values in Excel.
            XLSX.utils.sheet_add_aoa(ws, [["Totals", +this.filteredReviews.length]], { origin: cell }); // we write starting from cell J + number value of cell

            XLSX.utils.book_append_sheet(wb, ws, "Reviews");
            XLSX.writeFile(wb, 'reviews.xlsx');

        },
        getScores() {

            console.log('this.params', this.params)

            this.scores = [
                { code: "1", description: "1" },
                { code: "2", description: "2" },
                { code: "3", description: "3" },
                { code: "4", description: "4" },
                { code: "5", description: "5" },
            ];            
            if (this.params[0] !== 'huis' && this.params[0] !== 'user') {
                this.selected_scores = ["1", "2", "3"];
            } 
            if (this.params[4] === 'false') {
                this.selected_scores = ["1", "2", "3", "4", "5"];
            }
        },
        toggle0() { console.log('filter changed; clear selection to avoid hidden selected records'); this.clearSelection(); },
        toggle() {
            this.$nextTick(() => {
                if (this.selectAll) {
                    this.selected_revwstats = [];
                } else {
                    this.selected_revwstats = this.revwstats.slice(); //
                }
            })
        },
        toggle2() {
            this.$nextTick(() => {
                if (this.selectAll2) {
                    this.selected_revwpartners = [];
                } else {
                    this.selected_revwpartners = this.revwpartners.slice(); //
                }
            })
        },
        toggle3() {
            this.$nextTick(() => {
                if (this.selectAll3) {
                    this.selected_scores = [];
                } else {
                    this.selected_scores = this.scores.slice(); //
                }
            })
        },
        toggle4() {

            // console.log('toggle4', 'all selected', this.selectAll4);


            this.$nextTick(() => {
                if (this.selectAll4) {
                    this.clearSelection();
                } else {
                    this.allSelection() //
                }
            })
        },

        getRevwStats2() {
            if (this.params[0] === 'huis'){
                this.$axios
                    .post("ares/json/ares/task/customer_success/revw/getRevwStats.p", { // all stat incl. published and closed
                        header: {
                            token: this.$session.get("ARES"),
                            clientSessionId: this.$session.id(),
                            request: "getRevwStats"
                        }
                    })
                    .then(res => {
                        if (res.data.error) {
                            console.log(res.data.error);
                        } else {
                            this.revwstats = res.data.getRevwStats;
                            this.setInitialSelections();
                        }
                    });
            } else { // all and user
                if(this.params[4] === 'true') {
                    this.$axios
                    .post("ares/json/ares/task/customer_success/revw/getRevwStatsStd.p", { // no published and closed stats
                        header: {
                            token: this.$session.get("ARES"),
                            clientSessionId: this.$session.id(),
                            request: "getRevwStats"
                        }
                    })
                    .then(res => {
                        if (res.data.error) {
                            console.log(res.data.error);
                        } else {
                            this.revwstats = res.data.getRevwStats;
                            this.setInitialSelections();
                        }
                    });
                } else {
                    this.$axios
                    .post("ares/json/ares/task/customer_success/revw/getRevwStatsNotPublished.p", { // no published and closed stats
                        header: {
                            token: this.$session.get("ARES"),
                            clientSessionId: this.$session.id(),
                            request: "getRevwStats"
                        }
                    })
                    .then(res => {
                        if (res.data.error) {
                            console.log(res.data.error);
                        } else {
                            console.log('revwstats 2', res.data.getRevwStats);
                            this.revwstats = res.data.getRevwStats;
                            this.setInitialSelections();
                        }
                    });
                }
            }    
        },
        getRevwPartners() {
            this.$axios
                .post("ares/json/ares/task/customer_success/revw/getPartnerList.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getRevwPartners"
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.revwpartners = res.data.getRevwPartners;
                        this.setInitialSelectionPartner();
                    }
                });
        },
        loadData() {

            // console.log('loadData');
            this.getScores();            
            this.getGebr();
            this.getRevwPartners();
            this.getRevwStats2();
            this.getOverViewDist();
        },
        setInitialSelections() {
            this.selected_revwstats = [];
            /*
            if (this.params[0] !== 'huis') {
                console.log("setInitialSelections start");
                this.selected_revwstats = [];
                this.revwstats.forEach((element) => {
                    if (element.code !== "Published" && element.code !== "Closed - not Published") { // these are initially never selected
                        this.selected_revwstats.push(element.code);
                    }
                });
            } 
            */   
        },
        setInitialSelectionPartner() {
            this.selected_revwpartners = [];
            /*
            if (this.params[0] !== 'huis' && this.params[0] !== 'user') {
                this.selected_revwpartners = [];
                this.revwpartners.forEach((element) => {
                    this.selected_revwpartners.push(element.code);
                });
            }
            */
        },
        showReaction(table, encrid, header, type) {
            //console.log('show reaction', key);
            this.$axios
                .post("ares/json/ares/huis/revw/getReviewTexts.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getReviewTexts"
                    },
                    getReviewTexts: {
                        table: table,
                        encrid: encrid,
                        type: type,
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.showText(header, res.data.getReviewTexts.Texts, res.data.getReviewTexts.open_tab);
                    }
                })
                .finally(() => {
                });
        },
        getDateFormat(isodate) {
            try {
                var d = new Date(isodate);
                if (isNaN(d.getTime())) {                    
                    return "?"; // Invalid date
                }
                return ("0" + d.getDate()).slice(-2) + "-" + ("0" + (d.getMonth() + 1)).slice(-2) + "-" + d.getFullYear(); // dd-mm-yyyy
            } catch (err) {
                return isodate;
            }
        },
        getOverViewDist() {

            //console.log('getOverViewDist');

            this.loading = true;
            this.$axios
                .post("ares/json/ares/task/customer_success/revw/getRevwOverviewDistv3.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getRevwOverview"
                    },
                    getRevwOverview: {
                        params: this.params,
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.reviews = res.data.getRevwOverview.revw;
                        this.title = ('Review overview ' + res.data.header.entityvalue);
                        this.resetdate = res.data.header.reset_date.toLowerCase();
                        this.user = res.data.header.user;
                    }
                })
                .finally(() => {
                    this.loading = false;
                    //apply filter ?
                });
            },
        showText(header, texts, tab) {
            this.$refs.showtext.open(header, texts, tab);
        },
        showReview(review) {
            // console.log(table, encrid);
            review.item.isLoading = true; // set loading to true to show progress indicator
            this.$refs.showreview.open(review);
        },      
        getAuth(){
           // return localStorage.getItem('login')==='dennis'||localStorage.getItem('login')==='guus';
           return false;
        },          
        clearSelection() {
            this.selected_selected = [];
            this.filteredReviews.forEach((element) => { element.selected = false; })

            // console.log('clear', this.selected_selected.length, this.filteredReviews.length);

            //this.reviews.forEach((element) => {
            //  element.selected=false;
            //});             
        },
        allSelection() {
            this.selected_selected = this.filteredReviews;
            this.filteredReviews.forEach((element) => { element.selected = true; })
            // console.log('select all', this.selected_selected.length, this.filteredReviews.length);
            //this.filteredReviews.forEach((element) => {
            //  element.selected=true;
            //});             
        },
        stopSpinner(review) {
            var idx = this.findWithAttr(this.filteredReviews, "encrid", review.item.encrid);
            if (idx !== -1) {
                setTimeout(() => {
                    this.filteredReviews[idx].isLoading = false; // set loading to false to stop progress indicator
                }, 250);
            }
        }
    }
}
</script> 
  
<style scoped>

    .td_markup {
        vertical-align: top;
        border-top: 5px solid transparent;
        font-size: 12px !important;
        /* trick to add padding to a TD element (which is not possible with CSS normally) */
    }

    .checkbox_markup {
        vertical-align: top;
        border-top: 5px solid transparent;
        /* trick to add padding to a TD element (which is not possible with CSS normally) */
    }

    .subtitle-weight {
        font-weight: 400;
    }

    .logo_row_2 {
        cursor: pointer;
    }

    .score {
        cursor: default;
        padding-bottom: 4px !important;
        font-size: 15px !important;
    }

    .acco_score1 {
        background: transparent !important;
        border: 2px solid #FD535E;
    }
    .acco_score2 {
        background: transparent !important;
        border: 2px solid #FD7B3F;
    }
    .acco_score3 {
        background: transparent !important;
        border: 2px solid #FCC700;
    }
    .acco_score4 {
        background: transparent !important;
        border: 2px solid #65D557;
    }
    .acco_score5 {
        background: transparent !important;
        border: 2px solid #0FC771;
    }
    .go {
        color: green;
    }    
    .nogo {
        color: #FD535E;
    }        
    .wrn{
        background-color: #FD7B3F40 !important;
    }
</style>